<template>
  <div class="esp_page_wrap">
    <div class="esp_page" :style="{backgroundColor: bgColor}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EspPage',
    data() {
      return {}
    },
    props: {
      bgColor: {
        type: String,
        default: '#ffffff'
      }
    }
  }
</script>

<style scoped lang="less">
  .esp_page_wrap {
    height: 100%;
    padding: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    .esp_page {
      height: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 2px;
      box-shadow: 0 0 3px rgb(0 0 0 / 13%);
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPage.vue